import { render, staticRenderFns } from "./batchDeviceList.vue?vue&type=template&id=5883d03b&scoped=true&"
import script from "./batchDeviceList.vue?vue&type=script&lang=js&"
export * from "./batchDeviceList.vue?vue&type=script&lang=js&"
import style0 from "./batchDeviceList.vue?vue&type=style&index=0&id=5883d03b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883d03b",
  null
  
)

export default component.exports